
import { ColorScheme } from '@/types'
import { CircularProgress, type CircularProgressProps, useTheme } from '@chakra-ui/react'
import React from 'react'

interface Props extends CircularProgressProps {
  colorScheme?: ColorScheme,
}

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  const { colorScheme = 'primary' } = props
  const color = `scene.${colorScheme}.normal`

  return (
    <CircularProgress color={color} { ...props } />
  )
})


export {
  Component as CircularProgress,
  type CircularProgressProps,
}